/**
 * Énumérations du savings-service (guide v3.1 §6.10 / annexe A).
 *
 * Les valeurs circulent en chaînes MAJUSCULES et sont transmises
 * littéralement : une valeur inconnue provoque une erreur de conversion
 * côté serveur, pas un défaut silencieux (§4.4).
 */

/** Statut d'un coffre d'épargne (`SavingsVaultStatus`). */
export const SAVINGS_VAULT_STATUSES = ["OPEN", "CLOSED"] as const;
export type SavingsVaultStatus = (typeof SAVINGS_VAULT_STATUSES)[number];

/** Type d'événement de blocage (`LockEventType`, champ `action` du DTO). */
export const LOCK_EVENT_TYPES = ["LOCKED", "EXTENDED", "EARLY_UNLOCKED"] as const;
export type LockEventType = (typeof LOCK_EVENT_TYPES)[number];

/** Auteur d'un événement de blocage (`LockEventActor`, champ `performedBy`). */
export const LOCK_EVENT_ACTORS = ["OWNER", "BACK_OFFICE"] as const;
export type LockEventActor = (typeof LOCK_EVENT_ACTORS)[number];

/**
 * Sens d'un mouvement de coffre vu du portefeuille principal
 * (`DEBIT` = versement vers le coffre, `CREDIT` = retrait du coffre).
 */
export const SAVINGS_MOVEMENT_DIRECTIONS = ["DEBIT", "CREDIT"] as const;
export type SavingsMovementDirection =
  (typeof SAVINGS_MOVEMENT_DIRECTIONS)[number];

/**
 * Statut d'un mouvement — reflète celui de wallet-service : COMPLETED cas
 * nominal, PENDING si la comptabilisation est en attente (rejouer la même
 * clé relit le statut), FAILED si l'opération a été refusée (`failureReason`).
 */
export const SAVINGS_MOVEMENT_STATUSES = ["PENDING", "COMPLETED", "FAILED"] as const;
export type SavingsMovementStatus = (typeof SAVINGS_MOVEMENT_STATUSES)[number];
